import React from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ProductSection from "./components/ProductSection";
import CheckoutPage from "./components/CheckoutPage";
import PreOrderPage from "./components/PreOrderPage";
import Footer from "./components/Footer";

function App() {
  const [showCheckout, setShowCheckout] = React.useState(false);
  const [showPreOrder, setShowPreOrder] = React.useState(false);

  const handleCartClick = () => {
    setShowCheckout(true);
    setShowPreOrder(false);
  };

  const handlePreOrderClick = () => {
    setShowPreOrder(true);
    setShowCheckout(false);
  };

  const handleBackToHome = () => {
    setShowCheckout(false);
    setShowPreOrder(false);
  };

  return (
    <CartProvider>
      <div className="App">
        <Header onCartClick={handleCartClick} />
        {showCheckout ? (
          <main className="main-content">
            <CheckoutPage onBack={handleBackToHome} />
          </main>
        ) : showPreOrder ? (
          <main className="main-content">
            <PreOrderPage onBack={handleBackToHome} />
          </main>
        ) : (
          <main className="main-content">
            <Hero onPreOrderClick={handlePreOrderClick} />
            <ProductSection />
          </main>
        )}
        <Footer />
        <Toaster position="top-right" />
      </div>
    </CartProvider>
  );
}

export default App;
